import NProgress from "nprogress";

const LOADER_MARK = "__withGlobalLoader";
const ATTACHED_MARK = "__loadingBarAttached";

let activeRequests = 0;

NProgress.configure({
  showSpinner: false,
  trickleSpeed: 120,
  minimum: 0.08,
});

export const startRequest = () => {
  activeRequests += 1;

  if (activeRequests === 1) {
    NProgress.start();
  }
};

export const endRequest = () => {
  activeRequests = Math.max(0, activeRequests - 1);

  if (activeRequests === 0) {
    NProgress.done();
  }
};

const shouldTrackRequest = (config) => config?.showLoader !== false;

export const attachLoadingInterceptors = (client) => {
  if (!client || client[ATTACHED_MARK]) {
    return client;
  }

  client.interceptors.request.use(
    (config) => {
      if (shouldTrackRequest(config)) {
        config[LOADER_MARK] = true;
        startRequest();
      }

      return config;
    },
    (error) => {
      if (error?.config?.[LOADER_MARK]) {
        endRequest();
      }

      return Promise.reject(error);
    }
  );

  client.interceptors.response.use(
    (response) => {
      if (response?.config?.[LOADER_MARK]) {
        endRequest();
      }

      return response;
    },
    (error) => {
      if (error?.config?.[LOADER_MARK]) {
        endRequest();
      }

      return Promise.reject(error);
    }
  );

  client[ATTACHED_MARK] = true;
  return client;
};